import { Component } from '@angular/core';

@Component({
    selector: 'app-external-home',
    templateUrl: './external-home.component.html',
    styleUrls: ['./external-home.component.scss'],
    standalone: false
})
export class ExternalHomeComponent {}
